const BOUNDS_KEYS = Object.freeze(["north", "south", "east", "west"]);
const BOUNDS_PRECISION = 6;

/** Returns finite, complete latitude/longitude bounds rounded to the legacy search precision. */
export function normalizeMapBounds(bounds) {
  const normalized = {};
  for (const key of BOUNDS_KEYS) {
    const raw = bounds?.[key];
    if (raw == null || (typeof raw !== "number" && typeof raw !== "string") || String(raw).trim() === "") {
      return;
    }
    const value = Number(raw);
    const limit = ["north", "south"].includes(key) ? 90 : 180;
    if (!Number.isFinite(value) || Math.abs(value) > limit) {
      return;
    }
    normalized[key] = Number(value.toFixed(BOUNDS_PRECISION));
  }
  if (normalized.north < normalized.south) {
    return;
  }
  return normalized;
}
